module.exports = __webpack_public_path__ + "img/watermark.723f1e5a.jpg";